import Logo from "./Logo";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

//footer component
const Footer = ({footerData, items}) => {
    const newLocation = useLocation();
    const [activeLink, setActiveLink] = useState({ initialValue: items[0] });

  useEffect(() => {
    if (!!items && newLocation.pathname === '/' && newLocation.hash === '') {

      window.scrollTo({ top: 0, behavior: 'smooth' });
      setActiveLink(items[0]);
    } else if (newLocation.pathname !== '/') {
      setActiveLink(null);
    }
    else if (!!items && newLocation.pathname === '/' && newLocation.hash) {
      const targetId = newLocation.hash.split('#')[1];
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        setActiveLink(items.find((item) => item.ref_link_href && item.ref_link_href.includes(newLocation.hash)));
        window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
      }
    }

  }, [items, newLocation.pathname]);

  const handleScrollToLink = (event) => {

    if (!!items && newLocation.pathname === '/' && newLocation.hash === '') {

        window.scrollTo({ top: 0, behavior: 'smooth' });
        setActiveLink(items[0]);
      } else if (newLocation.pathname !== '/') {
        setActiveLink(null);
      }
      else if (!!items && newLocation.pathname === '/' && newLocation.hash) {
        const targetId = newLocation.hash.split('#')[1];
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          setActiveLink(items.find((item) => item.ref_link_href && item.ref_link_href.includes(newLocation.hash)));
          window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
        }
      }
    
    // event.preventDefault();
     if (event.target.host !== window.location.host || window.location.pathname !== event.target.pathname)  {
       window.location.href = event.target.href;
       return;
     }
     const targetId = event.target.href.split('#')[1];
     const targetElement = document.getElementById(targetId);
     //window.location.href = event.target.href
     if (targetElement) {
       
       window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
     }
     
 
     const currentActiveLink = event.target.closest('li');
     currentActiveLink.classList.add('active');
   
     // Remove active class from previous active link
     const previousActiveLink = document.querySelector('.nav-item.active');
     previousActiveLink && previousActiveLink.classList.remove('active');
 
    
   };


    return(
    
      
      <footer className="footer" id="footer">
    
      {/* <div className="skew-divider-top"></div> */}
        <div className="footer-top new-footer">
            <div className="container">
                <hr></hr>
            <div className="row">
                <div className="col-12 single-row footer-content-row">
                    <div className="tram-footer-logo footer-widget">
                        <ul className="list-unstyled">
                            <li><a>{footerData.copywright}</a></li>
                        </ul>
                        <p className="footer-tagline">Empowering outcome-driven musculoskeletal healthcare.</p>
                    </div>
                    <div className="footer-contact">
                        <a href="mailto:info@orthoped.ai" className="footer-email">info@orthoped.ai</a>
                    </div>
                    <div className="tram-static-content-link footer-widget">
                        <ul className="list-unstyled single-row">
                        {footerData.footer1 && footerData.footer1.map((footerMenuItem, index) => (
                           <li key={index}>
                           {footerMenuItem._type === 'linkInternal' ?
                                (<Link to={footerMenuItem.slug.startsWith('/') ? footerMenuItem.slug : `/${footerMenuItem.slug}`}  onClick={(event) => handleScrollToLink(event)}>{footerMenuItem.title}</Link>)
                                :( <Link to={`${footerMenuItem.slug}`} target="_blank">{footerMenuItem.title}</Link>)}
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>
        {/* <div className="footer-top hide">
            <div className="container">
                <div className="row">
                  
                    <div className="col-12 col-md-6 col-lg-3">
                    <div className="footer-logo">
                        <Logo logo={footerData.footerLogo}></Logo>
                    </div>
                    <p>{footerData.footerContent}</p>
                    <div className="footer-social">
                        <ul className="list-unstyled">
                            <li> <a href={footerData.twiter} target="_blank">
                                <i className="fab fa-twitter"></i></a></li>
                            <li> <a  href={footerData.fb} target="_blank">
                                <i className="fab fa-facebook-f"></i></a></li>
                            <li> <a href={footerData.insta} target="_blank"><i className="fab fa-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
                   
                    
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="footer-widget"> 
                        {footerData.footer1 && 
                            <h6 className="widget-title">{footerData.footer1.footerTitle}</h6>
                        }
                            <ul className="list-unstyled">
                            {footerData.footer1 && footerData.footer1.footerMenu1.map((footerMenuItem, index) => (
                                <li key={index}> 
                                    {footerMenuItem._type === 'linkInternal' ?
                                    (<Link to={`/${footerMenuItem.slug}`}  onClick={(event) => handleScrollToLink(event)}>{footerMenuItem.title}</Link>)
                                    :( <Link to={`${footerMenuItem.slug}`} target="_blank">{footerMenuItem.title}</Link>)}
                                </li>
                            ))}
                            </ul>
                        </div>
                    </div>

                     <div className="col-12 col-md-6 col-lg-3">
                        <div className="footer-widget">
                        {footerData.footer2 &&  
                            <h6 className="widget-title">{footerData.footer2.footerTitle}</h6>
                        }
                            <ul className="list-unstyled">
                            {footerData.footer2 && footerData.footer2.footerMenu2.map((footerMenuItem, index) => (
                                <li key={index}> 
                                    {footerMenuItem._type === 'linkInternal' ?
                                    (<Link to={`/${footerMenuItem.slug}`}  onClick={(event) => handleScrollToLink(event)}>{footerMenuItem.title}</Link>)
                                    :( <Link to={`${footerMenuItem.slug}`} target="_blank">{footerMenuItem.title}</Link>)}
                                </li>
                            ))}
                            </ul>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="footer-widget"> 
                        {footerData.footer3 && 
                            <h6 className="widget-title">{footerData.footer3.footerTitle}</h6>
                        }
                            <ul className="list-unstyled">
                            {footerData.footer3 && footerData.footer3.footerMenu3.map((footerMenuItem, index) => (
                                <li key={index}> 
                                    {footerMenuItem._type === 'linkInternal' ?
                                    (<Link to={`/${footerMenuItem.slug}`}  onClick={(event) => handleScrollToLink(event)}>{footerMenuItem.title}</Link>)
                                    :( <Link to={`${footerMenuItem.slug}`} target="_blank">{footerMenuItem.title}</Link>)}
                                </li>
                            ))}
                            </ul>
                        </div>
                    </div> 

                   
                    
                </div>
            </div>
        </div> */}
        {/* <div className="footer-bottom hide">
            <div className="container">
                <hr></hr>
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12 text--center">
                        <div className="footer-copyright">
                            <span>{footerData.copywright}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
      </footer>
                   
      
    );
}
  
export default Footer;